/* eslint-disable no-restricted-syntax */
import axios from 'axios'

export default {
  /**
   * Post campaign
   * @param {Object} - campaign object
   */
  saveCampaign: async ({ commit, dispatch, state, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'saveCampaign', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      if (Array.isArray(payload.Zones)) {
        commit('setCampaignValue', {
          key: 'Zones',
          value: `|${payload.Zones.join('|')}|`
        })
      }
      if (state.isNew) {
        commit('setCampaignValue', {
          key: 'ID',
          value: 0
        })
        commit('setCampaignValue', {
          key: 'IsTemplate',
          value: false
        })
      }
      if (payload.ID > 0 || payload.Id > 0) {
        await axios
          .put(
            `${process.env.VUE_APP_URL}/adminapi/discountcampaigns`,
            payload,
            config
          )
          .then(response => {
            commit('setCampaignInCampaignsArray', response.data)
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: 'Campaign updated successfully!'
              },
              { root: true }
            )
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
        dispatch('saveTranslation')
      } else {
        await axios
          .post(
            `${process.env.VUE_APP_URL}/adminapi/discountcampaigns`,
            payload,
            config
          )
          .then(response => {
            commit('addCampaign', response.data)
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: 'New campaign added successfully!'
              },
              { root: true }
            )
            commit(
              'app/setLoading',
              { type: 'saveCampaign', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
      }
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'saveCampaign', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  getCampaigns({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getCampaigns', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      // const count = 0
      axios
        .get(`${process.env.VUE_APP_URL}/adminapi/discountcampaigns`, config)
        .then(response => {
          const campaigns = response.data
          commit('setCampaigns', campaigns)
          resolve()
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getCampaigns', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  getTranslation({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getCampaigns', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      // const count = 0
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/translation/${payload.language}/${payload.textCode}`,
          config
        )
        .then(response => {
          const translations = response.data.Text // server returns a JSON object with field Text (and some other irrelevant ones)
          // commit('setTranslations', translations)
          resolve(translations)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getCampaigns', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  saveTranslation({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getCampaigns', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      const languageKeys = Object.keys(rootState.campaigns.translations)
      // eslint-disable-next-line guard-for-in
      languageKeys.forEach(language => {
        const textCode = `${'campaign'}${
          rootState.campaigns.campaign.ID
        }_thank_you_note`
        axios
          .put(
            `${process.env.VUE_APP_URL}/adminapi/translation/${language}/${textCode}/${rootState.campaigns.campaign.ID}`,
            {
              Text: rootState.campaigns.translations[language]
            },
            config
          )
          .then(response => {
            const translations = response.data.Text // server returns a JSON object with field Text (and some other irrelevant ones)
            // commit('setTranslations', translations)
            resolve(translations)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
            commit(
              'app/setLoading',
              { type: 'getCampaigns', state: false },
              { root: true }
            )
            commit('app/setError', error, { root: true })
            reject()
          })
      })
    })
  },
  /**
   * Gets and sets campaign by campaign id
   * @param {Number} id
   */
  getCampaign: async ({ commit, rootState, dispatch }, id) => {
    commit(
      'app/setLoading',
      { type: 'getCampaign', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/discountcampaigns/${id}`,
          config
        )
        .then(response => {
          if (response.data.ExtraDiscountCampaignId > 0) {
            response.data.ActivateExtraDiscountCampaign = true
            dispatch('getCampaigns')
          }
          commit('setCampaign', response.data)
          // console.log(rootState.campaigns.isTemplate)
          // commit('setCampaignValue', {
          //   key: 'IsTemplate',
          //   value: rootState.campaigns.isTemplate
          // })
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getWhitgetCampaignelist', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets and sets campaign registrants by campaign id
   * @param {Number} id - campaign id
   */
  getRegistrants: async ({ commit, rootState }, id) => {
    commit(
      'app/setLoading',
      { type: 'getRegistrants', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/discountcampaigns/${id}/registrants`,
          config
        )
        .then(response => {
          commit('setRegistrants', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getRegistrants', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Removes campaign
   * @param {Number} id - campaign id
   */
  removeCampaign: async ({ commit, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'getRegistrants', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .delete(`${process.env.VUE_APP_URL}/adminapi/discountcampaigns`, {
          headers: config.headers,
          data: payload
        })
        .then(() => {
          commit('removeCampaignFromArray', payload.Id)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getRegistrants', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Removes campaign custom field
   * @param {Number} id - campaign id
   */
  deleteCustomField: async ({ commit, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'getRegistrants', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .delete(`${process.env.VUE_APP_URL}/adminapi/discountcampaigns`, {
          headers: config.headers,
          data: payload
        })
        .then(() => {
          commit('removeCampaignFromArray', payload.Id)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getRegistrants', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  generateCodes({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'generateCodes', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      // const count = 0
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/discountcampaigns/${payload.campaignId}/promo-codes/${payload.amountOfNewCodes}`,
          {},
          config
        )
        .then(response => {
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(response.data)
        })
        .catch(error => {
          // if (error.response.status === 401) {
          //   dispatch('authentication/logout', null, { root: true })
          // }
          commit(
            'app/setLoading',
            { type: 'generateCodes', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  getLinkDetails: async ({ commit, rootState }, uuid) => {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getLinkDetails', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .get(
            `${process.env.VUE_APP_URL}/adminapi/publiclinks/${uuid}`,
            config
          )
          .then(response => {
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
            resolve(response.data)
          })
      } catch (error) {
        commit(
          'app/setLoading',
          { type: 'getLinkDetails', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
        reject(error)
      }
    })
  },
  postRegistrants({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postRegistrants', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      // const count = 0
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/discountcampaigns/${payload.campaignId}/registrants?many=${payload.many}&invite=${payload.invite}`,
          payload.data,
          config
        )
        .then(response => {
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          response.data.forEach(registrant => {
            commit('addRegistrant', registrant)
          })
          resolve(response.data)
        })
        .catch(error => {
          // if (error.response.status === 401) {
          //   dispatch('authentication/logout', null, { root: true })
          // }
          commit(
            'app/setLoading',
            { type: 'postRegistrants', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  postRegistrant({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postRegistrants', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      // const count = 0
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/discountcampaigns/${payload.campaignId}/registrants`,
          payload.data,
          config
        )
        .then(response => {
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })

          commit('addRegistrant', response.data)
          resolve(response.data)
        })
        .catch(error => {
          // if (error.response.status === 401) {
          //   dispatch('authentication/logout', null, { root: true })
          // }
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : `Something went wrong! Please try again later.`
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'postRegistrants', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  }
}
